var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"shadow":"hover"},nativeOn:{"click":function($event){return _vm.toMap()}}},[_c('div',{staticClass:"desc"},[_c('h1',[_c('a',[_vm._v(_vm._s(_vm.Name))])]),_vm._v(" "),_c('p',[_vm._v("电话："+_vm._s(_vm.Tel))]),_vm._v(" "),_c('p',[_vm._v("地址："+_vm._s(_vm.Address))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b373969c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zwfwmap-phone/left_bdcsld_list/list_card.vue
// module id = null
// module chunks = 